"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloudFunction = exports.ResourceType = exports.NetworkSessionType = exports.UpdateStatus = exports.AnalyticsType = exports.PlayerType = void 0;
var PlayerType;
(function (PlayerType) {
    PlayerType["BITMOVIN"] = "Bitmovin";
    PlayerType["HLS"] = "HLS";
    PlayerType["MUX"] = "Mux";
    PlayerType["JWPLAYER"] = "JWPlayer";
})(PlayerType = exports.PlayerType || (exports.PlayerType = {}));
var AnalyticsType;
(function (AnalyticsType) {
    AnalyticsType["BITMOVIN"] = "Bitmovin";
    AnalyticsType["NPAW"] = "NPAW";
    AnalyticsType["MUX"] = "Mux";
})(AnalyticsType = exports.AnalyticsType || (exports.AnalyticsType = {}));
var UpdateStatus;
(function (UpdateStatus) {
    UpdateStatus[UpdateStatus["FORCE"] = 0] = "FORCE";
    UpdateStatus[UpdateStatus["RECOMMENDED"] = 1] = "RECOMMENDED";
    UpdateStatus[UpdateStatus["NO_UPDATE"] = 2] = "NO_UPDATE";
})(UpdateStatus = exports.UpdateStatus || (exports.UpdateStatus = {}));
var NetworkSessionType;
(function (NetworkSessionType) {
    NetworkSessionType["DEFAULT"] = "default";
    NetworkSessionType["AUTH"] = "auth";
})(NetworkSessionType = exports.NetworkSessionType || (exports.NetworkSessionType = {}));
var ResourceType;
(function (ResourceType) {
    ResourceType["MOVIE"] = "movie";
    ResourceType["SERIE"] = "serie";
})(ResourceType = exports.ResourceType || (exports.ResourceType = {}));
var CloudFunction;
(function (CloudFunction) {
    CloudFunction["CREATE_USER_PROFILE"] = "createUserProfile";
    CloudFunction["DELETE_USER_PROFILE"] = "deleteUserProfile";
    CloudFunction["UPDATE_USER_PROFILE"] = "updateUserProfile";
})(CloudFunction = exports.CloudFunction || (exports.CloudFunction = {}));
